import type { Handleiding } from './soort';

export const nl: Handleiding = {
  code: 'nl',
  titel: 'Handleiding',
  inleiding:
    'Ask Gio Tolk vertaalt een gesprek tussen twee mensen die elkaars taal niet spreken. Hieronder staat wat elke knop doet.',
  knop: 'Handleiding openen',
  sluiten: 'Sluiten',
  groepGebruik: 'Meepraten',
  groepBeheer: 'Instellen en beheren',
  delen: [
    {
      titel: 'Praten',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Spreek in',
          uitleg:
            'Tik één keer om te beginnen. De opname stopt vanzelf zodra je ruim een seconde stil bent, of als je nog een keer tikt. Na een minuut stopt hij hoe dan ook.',
        },
        {
          kop: 'Eén geluid tegelijk',
          uitleg:
            'Zolang de app praat, kun je niet opnemen. En zolang jij opneemt, wacht een binnengekomen vertaling tot je klaar bent. Anders neemt je microfoon de app op en denkt hij dat jij dat zei.',
        },
        {
          kop: 'Typ hier je bericht',
          uitleg:
            'Werkt naast inspreken en gaat door dezelfde vertaling. Enter verstuurt, shift met enter maakt een nieuwe regel.',
        },
        {
          kop: 'Tijd om te verbeteren',
          uitleg:
            'Zet hier hoeveel seconden je krijgt om je uitgeschreven zin na te lezen voordat hij weggaat. Op nul gaat hij meteen.',
        },
        {
          kop: 'Altijd zelf nakijken en versturen',
          uitleg:
            'Geen klok meer. Elke zin wacht tot jij op versturen drukt. Voor wie elke zin wil nakijken.',
        },
        {
          kop: 'Vertaling meteen afspelen',
          uitleg:
            'Staat aan. Zet hem uit als je liever eerst leest en zelf bepaalt wanneer je luistert.',
        },
      ],
    },
    {
      titel: 'Berichten lezen',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Wat groot staat',
          uitleg:
            'Wat in JOUW taal staat, staat groot. Bij je eigen zin is dat je originele tekst, zodat je kunt nakijken of de app je goed verstond. Bij een zin van de ander is dat de vertaling.',
        },
        {
          kop: 'Origineel of vertaald uitklappen',
          uitleg: 'De andere taal staat eronder, ingeklapt. Tik op de regel om hem te openen.',
        },
        {
          kop: 'Het driehoekje',
          uitleg: 'Speelt de vertaling opnieuw af.',
        },
        {
          kop: 'Het sprekende hoofd',
          uitleg:
            'Speelt de eigen opname van de ander af. Verschijnt alleen bij een INGESPROKEN bericht en alleen als "stuur ook je eigen stem mee" aanstaat. Bij een getypt bericht is er geen opname.',
        },
      ],
    },
    {
      titel: 'Knoppen boven in het scherm',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Min en plus',
          uitleg: 'Maakt de tekst kleiner of groter. In vijf stappen, en het blijft bewaard.',
        },
        {
          kop: 'De microfoon',
          uitleg: 'Verbergt de spreekknop als je toch alleen typt. Dat scheelt ruimte.',
        },
        {
          kop: 'Het toetsenbord',
          uitleg:
            'Verbergt het tekstvak. Er blijft er altijd één van de twee aan staan, anders kun je niets meer zeggen.',
        },
      ],
    },
    {
      titel: 'Binnenkomen',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Welke taal spreek jij',
          uitleg:
            'Deze keuze bepaalt ook de taal van de knoppen en de meldingen. Jullie zien dus allebei een ander scherm, en dat is de bedoeling.',
        },
        {
          kop: 'Jouw stem in de vertaling',
          uitleg:
            'Kies of je als man of vrouw klinkt. Dit hoort bij JOU, niet bij de kamer: allebei de deelnemers kiezen apart.',
        },
        {
          kop: 'Toestemming voor de microfoon',
          uitleg:
            'De browser vraagt dit bij het binnengaan. Zeg je nee, dan kun je nog steeds typen. Toestemming geven kan later alsnog via het slotje in de adresbalk.',
        },
      ],
    },
    {
      titel: 'Onderin, ingeklapt',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Vangnet-woordenlijst',
          uitleg:
            'Woorden die altijd op dezelfde manier vertaald moeten worden: namen, vaktermen, merken. Geldt voor de hele kamer.',
        },
        {
          kop: 'Instellingen aanpassen',
          uitleg:
            'Taal, stem, toon en spellingcorrectie zijn ook MIDDEN in het gesprek nog om te zetten. Wat je hier verandert geldt meteen voor allebei.',
        },
      ],
    },
    {
      titel: 'Een gesprek beginnen',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'Naam van het gesprek',
          uitleg:
            'Mag leeg blijven. Hij staat alleen boven in je scherm, zodat je weet met wie je praat.',
        },
        {
          kop: 'Spreker 1 en spreker 2',
          uitleg:
            'De twee talen van dit gesprek. Wie het eerst binnenkomt krijgt de eerste plek. Je kunt de talen later nog omzetten.',
        },
        {
          kop: 'Toon van de vertaling',
          uitleg:
            'Links kies je tutoyeren of vousvoyeren, rechts de sfeer: neutraal, vriendschappelijk, zakelijk, officieel of partner. Zonder sturing kiest het model bijna altijd de formele vorm, en dat klinkt in een gewoon gesprek afstandelijk.',
        },
        {
          kop: 'Stuur ook je eigen stem mee',
          uitleg:
            'De ander kan naast de vertaling ook jouw eigen opname horen. Handig om een taal te leren. Zet dit uit bij een gevoelig gesprek: wie de opname ontvangt, kan hem bewaren.',
        },
        {
          kop: 'Verbeter spelfouten in je eigen tekst',
          uitleg:
            'Staat aan. Zet het uit om te zien wat het model werkelijk verstond. Staat er dan een rare zin, dan weet je of hij verkeerd verstaan is of netjes verstaan en daarna gladgestreken.',
        },
        {
          kop: 'Pincode erbij',
          uitleg:
            'Geef de code mondeling door, niet in hetzelfde bericht als de link. Dat beschermt tegen een link die wordt doorgestuurd.',
        },
        {
          kop: 'De QR-code',
          uitleg:
            'Laat de ander deze scannen, of stuur de link. Een kamer vervalt vanzelf na vier uur.',
        },
      ],
    },
    {
      titel: 'Wat er met je gesprek gebeurt',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'De tekst wordt niet bewaard',
          uitleg:
            'Wat jullie zeggen komt niet in de database. Alleen wanneer en hoeveel er gepraat is, voor de kosten.',
        },
        {
          kop: 'Opnames verdwijnen vanzelf',
          uitleg: 'Audio blijft tien minuten in het geheugen en gaat daarna weg.',
        },
        {
          kop: 'De kamer vervalt',
          uitleg: 'Vier uur na het aanmaken. Daarna werkt de link niet meer.',
        },
        {
          kop: 'Er zit een budget op',
          uitleg:
            'Per kamer en per maand. Loopt het vol, dan stopt de app met vertalen en zegt hij dat. Dat is geen storing.',
        },
      ],
    },
  ],
};
